import { z } from "zod";
import { createActividadProgramaSchema } from "./createActividadPrograma.validacion";

export const editActividadProgramaSchema = createActividadProgramaSchema.extend(
  {
    id: z.number().int(),
  }
);
export type EditActividadProgramaInput = z.infer<
  typeof editActividadProgramaSchema
>;
